import { useOfferFiltersState } from "../context/OfferFiltersContext";
import PriceRangePicker from "./PriceRangePicker";
import StaticButtonGroup from "./StaticButtonGroup";
import React from "react";
export default function FocusedFilterContent({ filterId, }) {
    const { pathFilters } = useOfferFiltersState();
    const pathFilter = pathFilters.find((f) => f.id === filterId);
    if (!pathFilter)
        return <div className="flex-1"/>;
    return (<div className="flex-1 overflow-y-auto px-4 py-4">
      {pathFilter.type === "range" ? (<PriceRangePicker filter={pathFilter}/>) : (<StaticButtonGroup filter={pathFilter}/>)}
    </div>);
}
